<template>
  <div class="hello" style="
		background-color: #f6f6f6;">

    <div class="header">
      <div @click="backJump" style="color: #fff;padding-top: 10px;margin-left: 10px;">
        <span style="line-height: 30px;"><i class="van-icon van-icon-arrow-left van-nav-bar__arrow"></i>返回</span>
      </div>
      <div class="clear"></div>
      <img src="../assets/topback.png" style="width: 50%;height: 75%;float: right;margin-top: -10px;" alt="">
      <div>
        <h3><span>水</span>费后付费账单</h3>
      </div>
    </div>
    <div class="center" style="position: relative;">
      <div class="content">
        <div class="content_top">
          <div class="bt">
            <img src="../assets/water.png" >
            <span>水费</span>
          </div>
          <!-- <button style="width:50px;height:50px" @click="f5">刷新页面</button> -->
          <div id="topone">
            <span style="font-size: 15px;color: #8e8e8e;">识别编码信息</span><span style="font-size: 15px;float: right;">{{allBody.houseHoldNumber}}</span>
          </div>
          <div id="topone">
            <span style="font-size: 15px;color: #8e8e8e;">住址信息</span><span style="font-size: 15px;float: right;">{{allBody.address}}</span>
          </div>
          <div style="margin-top: 50px;margin-bottom: 20px;">
            <button @click="hhh" style="width: 80px;height:30px;border:1px solid #2d86f6;border-radius: 5px;text-align: center;float: left;background-color: #fff;color:#2d86f6;">
              {{content.billYear}}
            </button>
            <button @click="qisclick" style="width: 50px;height:30px;border:1px solid #2d86f6;border-radius: 5px;text-align: center;background-color: #fff;margin-left: 20px;color:#2d86f6;">
              {{content.billIssue}}
            </button>
            <div class="clear" style="clear: both;"></div>
            <van-popup v-model="show" position="bottom" style="width:100%;height: 30% ">
              <van-picker
                  title="请选择年"
                  show-toolbar
                  :columns="columns"
                  @confirm="onConfirmDate"
              />
            </van-popup>
            <van-popup v-model="qishow" position="bottom" style="width:100%;height: 30% ">
              <van-picker
                  title="请选择期数"
                  show-toolbar
                  :columns="periods"
                  @confirm="periodsonConfirm"
              />
            </van-popup>
          </div>
          <div style="border-bottom: 1px solid #dee1e5;">
					<span style="font-size: 20px;color: #0f72dd;float: left;">
						{{content.paymentAll}}
					</span>
            <div class="clear"></div>
            <div class="kuan">
              <span style="float: left;margin-top:8px;font-size: 10px;">合计金额（元)</span>
            </div>
            <div style="margin-bottom:10px">
						<span style="font-size: 12px;" v-if="content.billPeriodStart != ''" >
							用水周期：{{content.billPeriodStart}} - {{content.billPeriodEnd}}
						</span>
              <span style="font-size: 12px;" v-else >
							用水周期：
						</span>
            </div>
          </div>
          <div class="allz">
            <p style="font-size: 20px;color: #0f72dd;">{{content.usedTotal}}</p>
            <p style="font-size: 12px;">合计水量（t）</p>
            <p v-if="content.billPeriodEnd != ''" style="font-size: 12px;margin-top:10px">数据更新时间：{{content.billPeriodEnd}}</p>
            <p v-else style="font-size: 12px;margin-top:10px">数据更新时间：</p>
          </div>
        </div>
      </div>
      <div class="bottom" style="background-color: #fff;">
        <div class="content_bottom">
          <div style="text-align: left;font-size: 20px;margin-top:20px">
            <p style="color:#0f72dd;">水量使用情况</p>
            <table border="0" cellspacing="10" cellpadding="" style="width:100%;margin-top: 30px;font-size:15px;border-bottom: 1px solid #8e8e8e;">
              <thead>
              <tr>
                <th></th>
                <th align="center" valign="middle">单价</th>
                <th align="center" valign="middle">计费数量</th>
                <th align="center" valign="middle">金额</th>

              </tr>
              </thead>
              <tbody>
              <tr>
                <td align="center" valign="middle">用水详情</td>
                <td align="center" valign="middle">{{content.waterPrice}}</td>
                <td align="center" valign="middle">{{content.usedTotal}}</td>
                <td align="center" valign="middle">{{content.paymentAll}}</td>
              </tr>
              </tbody>
            </table>
            <table border="0" cellspacing="10" cellpadding="" style="width:100%;font-size: 15px;border-bottom: 1px solid #8e8e8e;">
              <thead>
              <tr>
                <th></th>
                <th align="center" valign="middle">上次/本次</th>
                <th align="center" valign="middle">抄见水量</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td align="center" valign="middle">总用水量</td>
                <td align="center" valign="middle">{{content.waterNumberLast}}/{{content.waterNumberThis}}</td>
                <td align="center" valign="middle">{{content.usedTotal}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <p style="font-size: 15px;margin-top: 20px;margin-bottom: 20px;"><span>手续费</span><span style="float: right;">{{content.taxPrice}}</span></p>

          <van-button @click="goJump" v-if="status == 0" type="primary" block style="background-color: #2D86F6;font-size: 17px;letter-spacing: 1px;height:50px;border-radius: 10px;">立即缴费</van-button>
          <van-button disabled v-else type="primary" style="background-color: #C8C9CC;font-size: 17px;letter-spacing: 1px;border-radius: 10px;height: 50px;width:100%">已完成缴费</van-button>

        </div>
      </div>
    </div>
    <div class="foot" style="background-color: #fff;">
      <div class="bot">
        <p style="color:#0f72dd">缴费服务</p>
        <div style="border-bottom:1px solid #8e8e8e;height: 70px;margin-top: 35px;">
          <img src="../assets/money.png" style="width:50px;float:left;" alt="">
          <div style="margin-left: 60px;">
            <span>缴费记录</span>
            <button @click="payment" style="border: none;width:80px;border-radius: 50px;background-color: #0f72dd;color:#fff;height:30px;line-height: 30px;float: right;margin-top: 10px;">进入</button>
            <p>可查询每笔缴费记录</p>
          </div>

        </div>
        <div>
          <img src="../assets/jil.png" style="width:50px;float:left;" alt="">
          <div style="margin-left: 60px;">
            <span>用量记录</span>
            <button @click="wateragain" style="border: none;width:80px;border-radius: 50px;background-color: #0f72dd;color:#fff;height:30px;line-height: 30px;float: right;margin-top: 10px;">进入</button>
            <p>日报、周报、月报</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import wx from 'weixin-js-sdk';
import {paymentOrder, waterContent,orderApp,orderQuery} from "../common/api/waterelall";
import jump from "../common/jump";
export default {
  data() {
    return {
      id:'',
      payer:'',
      text:'',
      wuy:'',
      show: false,
      start:'',
      end:'',
      showPicker:false,
      year:'2021',
      qis:'',
      allelectric:'',
      number:'',
      address:'',
      allmoney:'',
      allin:[],
      columns:[],
      zq:'',
      charge:'',
      phone:'',
      devId:'',
      mchNumber:'',
      projectId:'',
      payType:1,
      periods:[],
      qishow:false,
      houseHoldNumber:'',
      status:'',
      all:[],
      allBody:[],
      content:[]
    };
  },
  mounted(){
    this.gof5()
    this.getContent()
  },
  methods: {
    gof5(){
      this.allBody = this.$route.query
      var date = new Date();
      for(let i = 0;i<=5;i++){
        console.log(i)
        let year = date.getFullYear()-i
        this.columns.push(year)
      }
    },
    goJump(){
      this.price = this.math
      var data = JSON.stringify({
        "price": this.content.paymentAll,
        "devId": this.content.devId,
        "houseHoldNumber": this.allBody.houseHoldNumber,
        "payType": this.allBody.payType,
        "phone": this.allBody.phone,
        "devAddress": this.allBody.address,
        "useType": 3,
        "mchNumber": this.allBody.mchNumber,
        "mchName": this.allBody.mchName,
        "type":1,
        "billId":this.allBody.id,
        "tenantId":this.allBody.tenantId,
        "productId":this.allBody.productId,
        "payment":this.allBody.payType
      });
      console.log(data)
      paymentOrder(data).then((reson)=> {
        console.log(reson)
        this.jsap(reson.data.orderNo, this.allBody.devType)
      }).catch(function (error) {
        console.log(error);
      });

    },
    jsap(orderNo,devType){
      this.typ = window.__wxjs_environment
      var isWxMini = window.__wxjs_environment === 'miniprogram'     // 判断场景是否小程序
      const url = '/pages/logs/logs?orderNo='+orderNo +'&token=' + this.$cookies.get("token") + '&devType=' + devType

      if (isWxMini) {
        this.typ = "11跳转"
        wx.miniProgram.navigateTo({
          url: url
        });
      } else {
        this.$toast('请在微信端重新操作')
      }
    },
    payment(){
      this.$router.push({path:'/payment',query:{houseHold:this.number}})
    },
    qishows(){
      this.qishow = !this.qishow
    },
    qisclick(){
      this.qishows()
    },
    periodsonConfirm(value){
      waterContent({
          houseHoldNumber:this.houseHoldNumber,
          billYear :this.content.billYear,
          billIssue:value
        }).then((response)=>{
            this.status = response.data.items[0].status
            console.log(this.status)
            this.content = []
            if(response.data.items.length==0){

            }else{
              this.content = response.data.items[0]
            }

          })
      this.qishows()
    },
    getContent(){
      waterContent({
        houseHoldNumber:this.allBody.houseHoldNumber
      }).then((response)=>{
        this.status = response.data.items[0].status
        console.log(this.status)
        for(let i =0;i<response.data.items.length;i++){
          this.periods.push(response.data.items[i].billIssue)
        }
        console.log(response.data)
        this.content = response.data.items[0]
      }).catch(function (error) {
            console.log(error);
          });
    },
    wateragain(){
      this.$router.push({path:'/wateragain',query:{houseHold:this.houseHoldNumber,address:this.address}})
    },
    backJump(){
      this.$destroy()
      jump.$emit('back')
      this.$router.go(-1)
    },
    hhh(){
      this.show = ! this.show
    },
    onConfirmDate (value) {
      this.content.year = value
      console.log(value)
      waterContent({
        houseHoldNumber:this.houseHoldNumber,
        billYear :value
      }).then((response)=>{
        this.content = []
            this.periods =[]
        if(response.data.items.length==0){
        }else{
          let all =response.data.items.length
          this.qis = response.data.items[0].billIssue
          for(let i =0;i<all;i++){
            this.periods.push(response.data.items[i].billIssue)
          }
          this.content = response.data.items[0]
        }

      })
      this.hhh()
    },

  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m;
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s;
      return y + '.' + MM + '.' + d;
    },
  }
};
</script>

<style scoped>
*{
  margin:0;
  padding:0;
}
.header{
  width: 100%;
  height: 192px;
  background-color: #295ad0;
}

.header h3{
  letter-spacing:2px;
  color: rgb(255, 255, 255);
  line-height: 120px;
  position: relative;
  margin-left:20px
}
.header h3 span{
  border-bottom: 3px solid #fff;
}
.content{
  width: 90%;
  margin: 0 auto;

  background-color: #fff;
  padding-top: 10px;
  box-shadow: #dee1e5 0px 0px 15px -5px;
  border-radius: 10px;

  margin-top:-15px
}
.content_top{
  width: 80%;
  margin: 0 auto;
  height:500px;
}
.bt{
  margin-top:20px
}
.bt img{
  width: 38px;
  height:38px;
  float: left;
}
.bt span{
  line-height: 42px;
  margin-left: 10px;
  font-size: 20px;
}
#topone{
  margin-top: 20px;
}
select{
  float: left;
}
select option{
  font-size: 15px;
}
ul li{
  width:20%;
  height:50px;
  background-color: #51B1D9;
  float: left;
  list-style: none;
}
.kuan{
  height: 48px;
  margin-top:2px;

}
.sum{
  width: 63%;
  font-size: 10px;
  float: right;
  margin-top: 8px;
  margin-right: 15px;
}
.allz{
  margin-top: 20px;
}
.allz p{
  margin-top: 20px;
}
.clear{
  clear: both;
}
.bottom{
  width: 90%;
  height: 400px;
  margin: 0 auto;
  padding-top: 10px;
  box-shadow: #dee1e5 0px 0px 15px -5px;
  border-radius: 10px;
  margin-top: 20px;
}

.content_bottom{
  width: 80%;
  margin: 0 auto;
}
.foot{
  width: 90%;
  box-shadow: #dee1e5 0px 0px 15px -5px;
  border-radius: 10px;
  height:260px;
  margin: 0 auto;
  margin-top:30px;
  margin-bottom: 30px;
}
.bot{
  width: 80%;
  margin: 0 auto;
  padding-top: 30px;
}
.bot div{
  margin-top:20px
}
.bot div p{
  font-size: 14px;
  color: #8e8e8e;
  margin-top: 5px;
}
</style>
